function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { isFunction, chainFns } from './utils';
import SubMixin from './mixins/sub';
import ExpandIcon from './expandIcon.js';
import TableCell from './tableCell';
export default {
  components: {
    ExpandIcon: ExpandIcon,
    TableCell: TableCell
  },
  mixins: [SubMixin],
  props: {
    // 用来更新size
    uid: {
      type: String,
      required: true
    },
    rowPrefixCls: {
      type: String,
      default: ''
    },
    // 用于判断当前row还在不在渲染池中，减少不必要的计算
    index: {
      type: Number,
      required: true
    },
    // itemSize为0就认为是未知高度
    itemSize: {
      type: Number,
      default: 0
    },
    rowIdx: {
      type: Number,
      default: -1
    },
    record: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    cols: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    indent: {
      type: Number,
      default: 0
    },
    type: {
      type: String,
      default: 'row'
    },
    needExpand: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    size: function size() {
      var uid = this.uid,
          _this$scrollData = this.scrollData,
          validSizes = _this$scrollData.validSizes,
          sizes = _this$scrollData.sizes;
      return validSizes[uid] ? sizes[uid] : 0;
    },
    isHover: function isHover() {
      var currentHoverRow = this.currentHoverRow;
      return this.uid === currentHoverRow;
    },
    isSelected: function isSelected() {
      return this.record.$$_selected;
    },
    isExpanded: function isExpanded() {
      var expanderRowKeys = this.expanderRowKeys,
          uid = this.uid;
      return expanderRowKeys.indexOf(uid) > -1;
    },
    isExpandable: function isExpandable() {
      var record = this.record,
          expandedRowRender = this.expandedRowRender,
          childColName = this.childColName;
      return !!(record[childColName] && record[childColName].length) || !!expandedRowRender;
    },
    classes: function classes() {
      var _ref;

      var rowPrefixCls = this.rowPrefixCls,
          isHover = this.isHover,
          isSelected = this.isSelected;
      return _ref = {}, _defineProperty(_ref, rowPrefixCls, true), _defineProperty(_ref, "".concat(rowPrefixCls, "-hover"), isHover), _defineProperty(_ref, "".concat(rowPrefixCls, "-selected"), isSelected), _ref;
    },
    rowStyle: function rowStyle() {
      var fixed = this.fixed,
          size = this.size,
          itemSize = this.itemSize; // 左右固定表格的高度由中间表格来决定

      if (fixed) {
        if (itemSize || size) {
          return {
            height: "".concat(itemSize || size, "px")
          };
        }
      }

      return {};
    }
  },
  created: function created() {
    var rootVM = this.rootVM,
        onForceUpdate = this.onForceUpdate;
    rootVM.$on('scroll:forceUpdate', onForceUpdate);
    this.$once('hook:beforeDestroy', function () {
      rootVM.$off('scroll:forceUpdate', onForceUpdate);
    });
  },
  mounted: function mounted() {
    this.updateSize();
  },
  methods: {
    updateSize: function updateSize() {
      var _this = this;

      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.itemSize || this.fixed || !force && this.size) {
        return;
      }

      this.$nextTick(function () {
        var _this$scrollData2 = _this.scrollData,
            startIndex = _this$scrollData2.startIndex,
            endIndex = _this$scrollData2.endIndex,
            index = _this.index,
            uid = _this.uid;

        if (startIndex <= index && index < endIndex) {
          var _this$$el$getBounding = _this.$el.getBoundingClientRect(),
              height = _this$$el$getBounding.height;

          var size = Math.round(height);

          if (size && _this.size !== size) {
            var scrollData = _this.scrollData,
                rootVM = _this.rootVM,
                set = _this.$set;

            if (rootVM.$_undefinedSizeMap[uid]) {
              rootVM.$_undefinedSizeMap[uid] = undefined;
              rootVM.$_undefinedSizeCount -= 1;
            }

            set(scrollData.validSizes, uid, true);
            set(scrollData.sizes, uid, size);
          }
        }
      });
    },
    onForceUpdate: function onForceUpdate() {
      this.updateSize(true);
    },
    handleExpandChange: function handleExpandChange(e, expanded) {
      var record = this.record,
          rowIdx = this.rowIdx,
          uid = this.uid;
      this.rootVM.handleExpandChange(e, expanded, record, rowIdx, uid);
    },
    onClick: function onClick(e) {
      var isExpanded = this.isExpanded,
          handleExpandChange = this.handleExpandChange;
      handleExpandChange(e, !isExpanded);
    },
    handleRowHover: function handleRowHover(row) {
      this.rootVM.handleRowHover(row);
    },
    onMouseEnter: function onMouseEnter() {
      this.handleRowHover(this.uid);
    },
    onMouseLeave: function onMouseLeave() {
      this.handleRowHover(null);
    },
    renderExpandIcon: function renderExpandIcon() {
      var h = this.$createElement;
      var rowPrefixCls = this.rowPrefixCls,
          isExpanded = this.isExpanded,
          isExpandable = this.isExpandable,
          handleExpandChange = this.handleExpandChange,
          type = this.type;
      return h(ExpandIcon, {
        "attrs": {
          "iconPrefixCls": rowPrefixCls,
          "isExpanded": isExpanded,
          "isCanExpandRow": isExpandable,
          "needIndentSpaced": type === 'row'
        },
        "on": {
          "expand": handleExpandChange
        }
      });
    },
    renderExpandIconAsCell: function renderExpandIconAsCell() {
      var h = this.$createElement;
      var rowPrefixCls = this.rowPrefixCls,
          renderExpandIcon = this.renderExpandIcon;
      return h("td", {
        "class": "".concat(rowPrefixCls, "-expand-icon-cell")
      }, [renderExpandIcon()]);
    },
    reBindRowEvents: function reBindRowEvents() {
      var on = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var expandRowByClick = this.expandRowByClick,
          type = this.type,
          isAnyColumnsFixed = this.isAnyColumnsFixed,
          record = this.record,
          rowIdx = this.rowIdx,
          onClick = this.onClick,
          onMouseEnter = this.onMouseEnter,
          onMouseLeave = this.onMouseLeave;
      var nOn = on;

      if (!('mouseenter' in nOn)) {
        nOn.mouseenter = null;
      }

      if (!('mouseleave' in nOn)) {
        nOn.mouseleave = null;
      }

      if (expandRowByClick && !('click' in nOn)) {
        nOn.click = null;
      }

      return Object.keys(nOn).reduce(function (r, k) {
        var nr = r;
        var originFn = nOn[k];
        var fn = null;

        if (k === 'mouseenter' || k === 'mouseleave') {
          var nFn = k === 'mouseenter' ? onMouseEnter : onMouseLeave;
          fn = chainFns(originFn, type === 'row' && isAnyColumnsFixed ? nFn : null);
        } else if (k === 'click') {
          fn = chainFns(originFn, expandRowByClick ? onClick : null);
        } else {
          fn = chainFns(originFn);
        }

        if (fn) {
          nr[k] = function (e) {
            fn.call(null, e, record, rowIdx);
          };
        }

        return nr;
      }, {});
    },
    hasExpandIcon: function hasExpandIcon(colIdx) {
      var fixed = this.fixed,
          expandIconAsCell = this.expandIconAsCell,
          expandIconColIndex = this.expandIconColIndex,
          hideExpandTreeIcon = this.hideExpandTreeIcon;
      return fixed !== 'right' && !expandIconAsCell && !hideExpandTreeIcon && String(colIdx) === String(expandIconColIndex);
    },
    renderCells: function renderCells() {
      var h = this.$createElement;
      var rowPrefixCls = this.rowPrefixCls,
          fixed = this.fixed,
          record = this.record,
          cols = this.cols,
          rowIdx = this.rowIdx,
          indent = this.indent,
          hasExpandIcon = this.hasExpandIcon,
          renderExpandIcon = this.renderExpandIcon,
          type = this.type,
          needExpand = this.needExpand;
      return cols.map(function (col, i) {
        return h("table-cell", {
          "attrs": {
            "rowPrefixCls": rowPrefixCls,
            "fixed": fixed,
            "record": record,
            "rowIdx": rowIdx,
            "colIdx": i,
            "column": col,
            "indent": indent,
            "expand-icon": (indent !== 0 || needExpand) && type === 'row' && hasExpandIcon(i) && renderExpandIcon()
          }
        });
      });
    }
  },
  render: function render() {
    var h = arguments[0];
    var type = this.type,
        fixed = this.fixed,
        record = this.record,
        rowIdx = this.rowIdx,
        indent = this.indent,
        rowStyle = this.rowStyle,
        classes = this.classes,
        rowClass = this.rowClass,
        onRow = this.onRow,
        expandIconAsCell = this.expandIconAsCell,
        reBindRowEvents = this.reBindRowEvents,
        renderCells = this.renderCells,
        renderExpandIconAsCell = this.renderExpandIconAsCell;
    var rowProps = {};

    if (type === 'row' && isFunction(onRow)) {
      rowProps = _objectSpread({}, onRow(record, rowIdx));
    }

    var rowClassName = isFunction(rowClass) ? rowClass(record, rowIdx, indent) : rowClass;

    var _rowProps = rowProps,
        className = _rowProps.className,
        style = _rowProps.style,
        on = _rowProps.on,
        otherProps = _objectWithoutProperties(_rowProps, ["className", "style", "on"]);

    var cells = renderCells();
    var events = reBindRowEvents(on);

    if (fixed !== 'right' && type === 'row' && expandIconAsCell) {
      cells.unshift(renderExpandIconAsCell());
    }

    return h("tr", {
      "class": [classes, className, rowClassName],
      "style": [style, rowStyle],
      "attrs": _objectSpread({}, otherProps),
      "on": _objectSpread({}, events)
    }, [cells]);
  }
};